import { API } from "./types";
import { fetchResource } from "./utils";

export const getAgent = (id: string) =>
  fetchResource<API.Agent>(`/agents/${id}`);

export const getAgentNews = (
  id: string,
  options?: {
    limit?: number;
    offset?: number;
  }
) => {
  let route = `/agents/${id}/news`;
  const query = new URLSearchParams();
  if (options?.limit) query.append("limit", String(options.limit));
  if (options?.offset) query.append("offset", String(options.offset));
  if (query.toString()) route = `${route}?${query}`;
  return fetchResource<API.Article[]>(route);
};

export const getAgentPlayers = (id: string) =>
  fetchResource<API.AgentPlayer[]>(`/agents/${id}/players`);

export const getAgencyAgents = (id: string) =>
  fetchResource<API.AgencyAgent[]>(`/agencies/${id}/agents`);

  export const getAgency = (id: string) =>
  fetchResource<API.Agency[]>(`/agencies/list/${id}`);
